module.exports = {
	"ha": "nha",
	"id": 5.7,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by HSDA, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.23809523809523,
						"dataLabels": {
							"enabled": true,
							"format": "40"
						}
					},
					{
						"y": 69.04761904761905,
						"dataLabels": {
							"enabled": true,
							"format": "29"
						}
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": true,
							"format": "28"
						}
					},
					{
						"y": 52.38095238095239,
						"dataLabels": {
							"enabled": true,
							"format": "22"
						}
					},
					{
						"y": 21.428571428571427,
						"dataLabels": {
							"enabled": true,
							"format": "9"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.09302325581395,
						"dataLabels": {
							"enabled": true,
							"format": "167"
						}
					},
					{
						"y": 93.02325581395348,
						"dataLabels": {
							"enabled": true,
							"format": "160"
						}
					},
					{
						"y": 87.79069767441861,
						"dataLabels": {
							"enabled": true,
							"format": "151"
						}
					},
					{
						"y": 76.74418604651163,
						"dataLabels": {
							"enabled": true,
							"format": "132"
						}
					},
					{
						"y": 44.76744186046512,
						"dataLabels": {
							"enabled": true,
							"format": "77"
						}
					},
					{
						"y": null
					},
					{
						"y": 95.08196721311475,
						"dataLabels": {
							"enabled": true,
							"format": "58"
						}
					},
					{
						"y": 95.08196721311475,
						"dataLabels": {
							"enabled": true,
							"format": "58"
						}
					},
					{
						"y": 95.08196721311475,
						"dataLabels": {
							"enabled": true,
							"format": "58"
						}
					},
					{
						"y": 83.60655737704919,
						"dataLabels": {
							"enabled": true,
							"format": "51"
						}
					},
					{
						"y": 44.26229508196721,
						"dataLabels": {
							"enabled": true,
							"format": "27"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.500000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.42857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -59.09090909090908,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.9069767441860517,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.191616766467066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.625000000000002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.58278145695364,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.918032786885251,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.06896551724138,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -47.05882352941176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Northeast<br>n=42"
			},
			{
				"x": 9,
				"text": "Northern Interior<br>n=172"
			},
			{
				"x": 15,
				"text": "Northwest<br>n=61"
			}
		],
		"dataTable": {
			"Northeast": [
				42,
				40,
				29,
				28,
				22,
				9
			],
			"Northern Interior": [
				172,
				167,
				160,
				151,
				132,
				77
			],
			"Northwest": [
				61,
				58,
				58,
				58,
				51,
				27
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_7.json
// module id = 274
// module chunks = 0